import {
  getList,
  getSelectList,
  getOne,
  getOneByScore,
  getScoreResult
} from './getData'
import {
  setCreate,
  setUpdate,
  setDelete,
  setAspectScore,
  setFaultScore
} from './setData'

const acts = {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    listSelect: [],
    idSelected: '',
    score: {},
    faults: [],
    actSelected: {},
    scoreResults: [],
    judgesScores: [],
    categories: []
  },
  mutations: {
    updateList: (state, list) => {
      state.list = list || []
    },
    updateSelectList: (state, list) => {
      state.listSelect = []
      if (Array.isArray(list)) {
        list.forEach(item => state.listSelect.push(item))
      }
    },
    updateOne: (state, one) => {
      state.actSelected = one || {}
      if (one && one._id) state.idSelected = one._id
      else state.idSelected = ''
    },
    updateScoreResults: (state, scoreResults) => {
      state.scoreResults = scoreResults || []
    },
    updateJudgesScores: (state, judgesScores) => {
      state.judgesScores = judgesScores || []
    },
    updateLoading: (state, loading) => (state.loading = loading),
    updateClearOne: state => {
      state.actSelected = {}
      state.idSelected = ''
      state.categories = []
    },
    updateCategories: (state, categories) => {
      state.categories = categories || []
    },
    updateScore: (state, score) => {
      state.score = score || {}
    },
    updateFaults: (state, payload) => {
      let faults = []
      const pendingFaults = JSON.parse(localStorage.getItem('pendingFaults'))

      if (pendingFaults && pendingFaults[state.score._id]) {
        faults = pendingFaults[state.score._id]
      }

      payload.forEach(fault => {
        if (
          !faults.some(
            item =>
              item.judgeId === fault.judgeId && item.object === fault.object
          )
        ) {
          faults.push(fault)
        }
      })
      state.faults = faults
    }
  },
  actions: {
    setInit: ({ commit }) => getList(commit),
    setInitSelect: (context, payload = {}) => getSelectList(context, payload),
    setCreateNew: async ({ commit }, act) => {
      await setCreate(act, commit)
      getList(commit)
    },
    setUpdate: async ({ commit, dispatch, state }, act) => {
      delete act.scores
      await setUpdate(act)
      getList(commit)
      dispatch('setOne', act._id)
    },
    setDelete: async ({ commit }, id) => {
      await setDelete(id)
      getList(commit)
    },
    setOne: ({ commit }, id) => getOne(commit, id),
    setAspectScore: ({ commit }, { scoreId, aspectScore }) => {
      setAspectScore(scoreId, aspectScore)
    },
    setFaultScore: ({ commit, dispatch }, { scoreId, faultScore }) => {
      setFaultScore(scoreId, faultScore)
    },
    setScoreResults: ({ commit }, matchId) => {
      getScoreResult(commit, matchId)
    },
    setOneByScore: async ({ commit, dispatch }, { actId, matchId }) => {
      const { scores } = await getOneByScore(commit, actId)
      const score = scores.find(score => score._id === actId)
      commit('updateScore', score)
      if (score) commit('updateFaults', score.faults || [])
      if (matchId) dispatch('setScoreResults', matchId)
    },
    setClearOne: ({ commit }) => {
      commit('updateClearOne')
    },
    setClone: async ({ commit }, act) => {
      delete act._id
      delete act.scores
      act.name.forEach(item => (item.text += '_copy'))
      await setCreate(act, commit)
      getList(commit)
    }
  }
}

export default acts
